import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "quiz-work-stage-customizer__picture-selector"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Select ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInteractionButton = _resolveComponent("AppInteractionButton")!
  const _component_QuizSelectableButton = _resolveComponent("QuizSelectableButton")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "Let’s wrap this up!",
    description: "Choose an image that ‘sums you up’ and hit continue.",
    class: "quiz-work-stage-customizer",
    "is-vertically-aligned": true,
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[2] || (_cache[2] = ($event: any) => (_ctx.QuizService.close()))
  }, {
    actions: _withCtx(() => [
      (!_ctx.isSelectingPicture)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            onClick: _ctx.navigateNext,
            disabled: !_ctx.hasSelectedPicture || _ctx.QuizService.isSaving(),
            loading: _ctx.QuizService.isSaving()
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "loading"]))
        : (_openBlock(), _createBlock(_component_AppButton, {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSelectingPicture = false))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
    ]),
    default: _withCtx(() => [
      (!_ctx.isSelectingPicture)
        ? (_openBlock(), _createBlock(_component_AppInteractionButton, {
            key: 0,
            icon: "plus",
            description: "Select image",
            image: _ctx.hasSelectedPicture ? _ctx.selectedPictureObject : undefined,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSelectingPicture = true))
          }, null, 8, ["image"]))
        : _createCommentVNode("", true),
      (_ctx.isSelectingPicture)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QUIZ_CONTRIBUTION_STYLE_PICTURES, (picture) => {
              return (_openBlock(), _createBlock(_component_QuizSelectableButton, {
                class: "col-4",
                key: picture.id,
                selected: _ctx.selectedPictureId === picture.id,
                onClick: ($event: any) => (_ctx.selectPicture(picture.id))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: picture.src,
                    alt: ""
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["selected", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onQuizNavigation:back"]))
}